import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import Row from '../../ReactComponent/Row';
import Column from '../../ReactComponent/Column';
import { formatDisplayDateHuman, formatMoney } from '../../../utils/func';
import { H2, H3, P } from '../../../theme/typography';
import { SummaryForm } from './Step5';
import Alert from '../../../lib/ui/alert';
import {
  CategoryTitle,
  TextProperty,
  Terms,
} from '../css';
import { PaymentMethods } from '../../../utils/enums';
import { ContentBox } from './ContentBox/css';

const Step6 = ({
  formData = {},
  serviceLevelQuotes,
  chosenServiceLevelCode,
  quoteData,
  parentFields,
  billingAccounts,
  currencyCode,
}) => {
  // const allServicesUnapproved = serviceLevelQuotes && serviceLevelQuotes.length > 0
  //   && serviceLevelQuotes.every((s) => s.isApproved === false);

  const service = serviceLevelQuotes && serviceLevelQuotes.filter((service) => service.serviceLevelCode === chosenServiceLevelCode)[0];
  let description = '';
  if (service) {
    description = service.description;
  }

  // let step5Charges = 0;
  // let step5TotalCharges = 0;
  // let step5Tax = 0;
  // let step5TotalAmount = 0;
  let step5ExpDate = '';

  serviceLevelQuotes.map((data) => {
    // step5Charges = data.charges;
    // step5TotalCharges = data.totalCharges;
    // step5Tax = data.tax;
    // step5TotalAmount = data.totalAmount;
    step5ExpDate = data.expectedDeliveryDate;
    return 0;
  });

  const {
    charges, totalAmount, serviceLevelDescription, estimatedDeliveryDate, totalCharges, tax, serviceLevelCode,
  } = quoteData;

  const { accessorials } = formData;

  let protectedAccount = billingAccounts && billingAccounts.some((a) => a.accountNumber === formData.billTo && a.protected);

  // When "Add New" is used, the typed account number won't exist in billingAccounts — always protect rates
  // Credit Card payments use system-assigned bill-to accounts, so rates should remain visible
  if (formData.paymentMethod !== PaymentMethods.CreditCard
    && formData.billTo && billingAccounts && !billingAccounts.some((a) => a.accountNumber === formData.billTo)) {
    protectedAccount = true;
  }

  if (formData && formData.division === 'Sameday' && formData.paymentMethod) {
    if (formData.paymentMethod === 'Collect'
      || ((formData.paymentMethod === 'Third Party' && protectedAccount) || formData.billToMethod === 'EnterBillTo')) {
      protectedAccount = true;
    }
  }

  // const totalAmountCondition = totalAmount ? totalAmount.value === 0 : service && service.totalAmount.value === 0;
  const totalChargesCondition = totalCharges ? totalCharges.value === 0 : service && service.totalCharges.value === 0;

  const step5Condition = totalChargesCondition && chosenServiceLevelCode !== 'CBLTL' ? estimatedDeliveryDate : step5ExpDate;

  return (
    <>
      <Alert
        visible={(formData && formData.paymentMethod === PaymentMethods.CreditCard)}
        type="credit-card-payment-instructions"
        currencyCode={currencyCode}
      />
      <CategoryTitle>{parentFields.step6CategoryTitle2 && parentFields.step6CategoryTitle2.value}</CategoryTitle>
      {(totalChargesCondition && serviceLevelCode)
        ? (
          <Row>
            <ContentBox full="true">
              <Row>
                <Column $desktop={6} $tablet={6} $mobile={12}>
                  <TextProperty>
                    <P className="title">{parentFields.createShipmentServiceLevel && parentFields.createShipmentServiceLevel.value}</P>
                    <H3>{serviceLevelDescription || description}</H3>
                  </TextProperty>
                  <TextProperty>
                    <P className="title">{t('ExpectedDeliveryDate')}</P>
                    <H3>{formatDisplayDateHuman(step5Condition === null ? '' : step5Condition)}</H3>
                  </TextProperty>
                </Column>
                <Column>
                  <TextProperty>
                    <H3>{parentFields.rateConfirmationH3 && parentFields.rateConfirmationH3.value}</H3>
                  </TextProperty>
                </Column>
              </Row>
            </ContentBox>
          </Row>
        )
        // ) : (
        //   <Row>
        //     <ContentBox full="true">
        //       <Row>
        //         <Column $desktop={6} $tablet={6} $mobile={12}>
        //           <TextProperty>
        //             <P className="title">{parentFields.createShipmentServiceLevel && parentFields.createShipmentServiceLevel.value}</P>
        //             <H3>{serviceLevelDescription || description}</H3>
        //           </TextProperty>
        //           <TextProperty>
        //             <P className="title">{t('ExpectedDeliveryDate')}</P>
        //             <H3>{formatDisplayDateHuman(step5Condition === null ? '' : step5Condition)}</H3>
        //           </TextProperty>
        //         </Column>
        //         <Column $desktop={6} $tablet={6} $mobile={12}>
        //           {(totalChargesCondition && serviceLevelCode)
        //             ? (
        //               <TextProperty>
        //                 <H3>{parentFields.rateConfirmationH3 && parentFields.rateConfirmationH3.value}</H3>
        //               </TextProperty>
        //             )
        // ) : (totalAmountCondition && chosenServiceLevelCode === 'CBLTL') ? (
        //   { step5TotalCharges && step5TotalCharges.value === 0
        //     ?
        //     :
        //   }
        //   <TextProperty>
        //     <P className="title">
        //       {parentFields.createShipmentPriceTitle && parentFields.createShipmentPriceTitle.value}
        //     </P>
        //     {step5TotalCharges && step5TotalCharges.value > 0
        //     && (
        //     <H3 className="justified normal-weigth" key="tcharges">
        //       <span>{t('TotalCharges')}</span>
        //       {' '}
        //       <span>{formatMoney(step5TotalCharges.value, protectedAccount)}</span>
        //     </H3>
        //     )}
        //     {step5Charges && (step5Charges).map((step5Charges, index) => (
        //       step5Charges.amount.value > 0
        //     && (
        //     <H3 className="justified normal-weigth" key={index}>
        //       <span className="capitalize">{step5Charges && step5Charges.description && step5Charges.description.toLowerCase()}</span>
        //       {' '}
        //       <span>{formatMoney(step5Charges.amount.value, protectedAccount)}</span>
        //     </H3>
        //     )
        //     ))}
        //     {step5Tax && step5Tax.value > 0
        //     && (
        //     <H3 className="justified normal-weigth" key="tax">
        //       <span>{t('Tax')}</span>
        //       {' '}
        //       <span>{formatMoney(step5Tax.value, protectedAccount)}</span>
        //     </H3>
        //     )}
        //     <hr />
        //     <H2 className="justified total-title">
        //       <span>{parentFields.createShipmentTotal && parentFields.createShipmentTotal.value}</span>
        //       <span>
        //         <span>{formatMoney(step5TotalAmount ? step5TotalAmount.value : service && service.totalAmount.value, protectedAccount)}</span>
        //         {' '}
        //         <span>{totalAmount && totalAmount.currencyCode}</span>
        //       </span>
        //     </H2>
        //   </TextProperty>
        // ) : (
        : (
          <TextProperty>
            <P className="title">
              {parentFields.createShipmentPriceTitle && parentFields.createShipmentPriceTitle.value}
            </P>
            {totalCharges && totalCharges.value > 0
            && (
            <H3 className="justified normal-weigth" key="tcharges">
              <span>{t('TotalCharges')}</span>
              {' '}
              <span>{formatMoney(totalCharges.value, protectedAccount)}</span>
            </H3>
            )}
            {charges && (charges).map((charge, index) => (
              charge.amount.value > 0
            && (
            <H3 className="justified normal-weigth" key={index}>
              <span className="capitalize">{charge && charge.description && charge.description.toLowerCase()}</span>
              {' '}
              <span>{formatMoney(charge.amount.value, protectedAccount)}</span>
            </H3>
            )
            ))}
            {tax && tax.value > 0
            && (
            <H3 className="justified normal-weigth" key="tax">
              <span>{t('Tax')}</span>
              {' '}
              <span>{formatMoney(tax.value, protectedAccount)}</span>
            </H3>
            )}
            <hr />
            <H2 className="justified total-title">
              <span>{parentFields.createShipmentTotal && parentFields.createShipmentTotal.value}</span>
              <span>
                <span>{formatMoney(totalAmount ? totalAmount.value : service && service.totalAmount.value, protectedAccount)}</span>
                {' '}
                <span>{totalAmount && totalAmount.currencyCode}</span>
              </span>
            </H2>
          </TextProperty>
        )}
      {/* </Column>
      </Row>
      </ContentBox>
      </Row> */}
      {/* )} */}

      <SummaryForm formData={formData} accessorialsList={accessorials} hideCube parentFields={parentFields} />

      <Terms>
        <CategoryTitle>{parentFields.step6TermsAndConditions && parentFields.step6TermsAndConditions.value}</CategoryTitle>
        <P>{parentFields.step6TermsAndConditionsDesc && parentFields.step6TermsAndConditionsDesc.value}</P>
      </Terms>
    </>
  );
};

Step6.propTypes = {
  formData: PropTypes.object,
  serviceLevelQuotes: PropTypes.array,
  chosenServiceLevelCode: PropTypes.string,
  quoteData: PropTypes.shape({
    charges: PropTypes.array,
    totalAmount: PropTypes.object,
    serviceLevelDescription: PropTypes.string,
    estimatedDeliveryDate: PropTypes.string,
    totalCharges: PropTypes.string,
    tax: PropTypes.string,
    serviceLevelCode: PropTypes.string,
    isApproved: PropTypes.bool,
  }),
  parentFields: PropTypes.object,
  billingAccounts: PropTypes.array,
  currencyCode: PropTypes.string,
};

export default Step6;
